import { apiClient } from './client';

export type BulkReturnsSkippedOrFailed = {
  returnId: number;
  reason: string;
};

export type BulkReturnsWarning = {
  returnId: number;
  warning: string;
};

/** Shared CSV outcome envelope for MX bulk process and bulk cancel. */
export type BulkReturnsCsvResponse = {
  csvRowCount: number;
  succeeded: number[];
  warnings?: BulkReturnsWarning[];
  skipped: BulkReturnsSkippedOrFailed[];
  failed: BulkReturnsSkippedOrFailed[];
  notFound: number[];
  invalidValues: string[];
};

export type BulkProcessReturnsAction =
  | 'full_process'
  | 'process_exchanges'
  | 'process_refunds'
  | 'process_gift_cards'
  | 'process_non_refunds'
  | 'clear_flags'
  | 'replay_label_event'
  | 'retry_labels';

export function bulkProcessReturns (shopId: number | string, formData: FormData) {
  return apiClient.post<BulkReturnsCsvResponse>(
    `/${shopId}/returns/bulk-process`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
}

export function bulkCancelReturns (shopId: number | string, formData: FormData) {
  return apiClient.post<BulkReturnsCsvResponse>(
    `/${shopId}/returns/bulk-cancel`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
}

export function searchReturns (searchTerm: string) {
  return apiClient.post('/returns/search', { param: searchTerm });
}

export function fetchReturn (returnId: number | string) {
  return apiClient.post('/returns/fetch', { return_id: returnId });
}

export function fetchReturnRaw (returnId: number | string) {
  return apiClient.post('/returns/raw', { return_id: returnId });
}

export function fetchReturnLedger (returnId: number | string) {
  return apiClient.post('/returns/ledger', { return_id: returnId });
}

export function redoReturnLedger (returnId: number | string) {
  return apiClient.post('/returns/ledger/redo', { return_id: returnId });
}

export function fetchReturnTimeline (returnId: number | string) {
  return apiClient.post('/returns/timeline', { return_id: returnId });
}
